export default "__VITE_ASSET__a1i_9atw__"